import { RESERVATION_COLOR } from "../../constants";

const ReservationDot = ({ color, isExclusive, size = 14 }) => {
  const getDot = () => {
    if (isExclusive) {
      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "50%", backgroundColor: color }} />
          <div style={{ width: "50%", backgroundColor: RESERVATION_COLOR }} />
        </div>
      );
    }
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          margin: "0 auto",
          backgroundColor: color,
        }}
      />
    );
  };

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        margin: "0 auto",
        backgroundColor: color,
      }}
    >
      {getDot()}
    </div>
  );
};

export default ReservationDot;
